<div class="row">
  <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
    <h3>{{ "i18n.base.forgot-password.header" | translate }}</h3>
    <div class="e-card">
      <div class="e-card-content">
        @if (!forgotPasswordSuccess) {
          <form id="forgotPasswordForm" [formGroup]="forgotPasswordForm" autocomplete="on">
            <p>{{ "i18n.base.forgot-password.info" | translate }}</p>
            <div class="form-group">
              <label for="userName" class="required">{{ "i18n.base.forgot-password.userName" | translate }}</label>
              <input id="userName" name="username" type="text" autocomplete="username" class="form-control" formControlName="userName">
              <app-error-messages [control]="formFields.userName"></app-error-messages>
            </div>
            <div class="d-flex justify-content-end gap-2">
              <button type="submit" class="btn btn-primary order-2" (click)="formSubmit()" [disabled]="!forgotPasswordForm.valid">
                {{ "i18n.base.forgot-password.submit-button" | translate }}
              </button>
              <a type="button" class="btn btn-outline-secondary order-1" [routerLink]="loginRoute">
                {{ "i18n.base.forgot-password.back-button" | translate }}
              </a>
            </div>
          </form>
        }
        @if (forgotPasswordSuccess) {
          <div>
            <p class="success-message"><span class="e-icons icon-checkmark me-1"></span>{{ "i18n.base.forgot-password.success-info" | translate }}</p>
          </div>
        }
      </div>
    </div>
  </div>
</div>
